import { useEffect, useState, useTransition } from "react";

import { useDropdownSourceContext } from "@ryde/redux";
import { IDropdownItem, RydeUiUnit } from "@ryde/shared";

export const useDrawerNewOrDuplicate = (
  entity: RydeUiUnit,
): IDropdownItem[] => {
  const { getDropdownItems } = useDropdownSourceContext();
  const [items, setItems] = useState<IDropdownItem[]>([]);
  const [, startTransition] = useTransition();
  useEffect(() => {
    const getItems = async (): Promise<void> => {
      const dropdownItems = await getDropdownItems?.(entity);
      setItems(dropdownItems || []);
    };

    startTransition(() => {
      getItems();
    });
  }, [entity, getDropdownItems]);
  return items;
};
